import { useInitialDimension } from "client/hooks/utils/useInitialDimension";
import { Slider } from "components/common/Slider/Slider";
import { Translate } from "components/common/Translate/Translate";
import { useRef } from "react";
import { TextBox } from "store/features/memeGenerator/types";
import { useOpacity } from "./useOpacity";

export interface OpacityProps {
    textBox: TextBox;
}

export const Opacity = ({ textBox }: OpacityProps) => {
    const { handleOpacityChange } = useOpacity(textBox);
    const parentRef = useRef<HTMLDivElement>(null);
    const [initialWidth] = useInitialDimension(parentRef);
    return (
        <div
            className="flex flex-col gap-2 px-6"
            ref={parentRef}
            style={{
                width: initialWidth && `${initialWidth}px`,
            }}
        >
            <label className="capitalize">
                <Translate keyName="opacity" />
            </label>
            <div className="flex items-center justify-between border border-irGray-200 dark:border-darkSurface-400 p-4 rounded-[10px] gap-4">
                <div style={{ width: "158px" }}>
                    <Slider
                        defaultValue={0}
                        value={textBox.opacity}
                        handleChange={handleOpacityChange}
                        max={100}
                        min={0}
                    />
                </div>
                <div className="translate-y-0.5">{textBox.opacity}%</div>
            </div>
        </div>
    );
};
